import { defineComponent as _defineComponent } from 'vue'
import {
    JOINT_ANGLE_MAX,
    JOINT_ANGLE_MIN,
    JointShape,
} from '@/modules/ConfiguratorJoints/composables/useShapeAndAngle';

// eslint-disable-next-line @typescript-eslint/no-var-requires
interface ShapeOption {
    value: JointShape;
    label: string;
    previewImage: string;
}

interface Props {
    selectedShape: JointShape | null;
    angle: number;
    angleInputKey: number;
}


export default /*#__PURE__*/_defineComponent({
  __name: 'ShapeAndAngle',
  props: {
    selectedShape: null,
    angle: null,
    angleInputKey: null
  },
  emits: ["update:selectedShape", "update:angle"],
  setup(__props: any, { emit }: { emit: ({
    (event: 'update:selectedShape', value: JointShape | null): void;
    (event: 'update:angle', value: number): void;
}), expose: any, slots: any, attrs: any }) {

const props = __props as {
    selectedShape: JointShape | null;
    angle: number;
    angleInputKey: number;
};

const externalCornerTypeImage: string = require('@/modules/ConfiguratorJoints/assets/corner-type-external.png');
// eslint-disable-next-line @typescript-eslint/no-var-requires
const internalCornerTypeImage: string = require('@/modules/ConfiguratorJoints/assets/corner-type-internal.png');

const shapeOptions: ShapeOption[] = [
    {
        value: 'external',
        label: 'External corner',
        previewImage: externalCornerTypeImage,
    },
    {
        value: 'internal',
        label: 'Internal corner',
        previewImage: internalCornerTypeImage,
    },
];




function onShapeChange(shape: JointShape) {
    const nextShape = props.selectedShape === shape ? null : shape;
    emit('update:selectedShape', nextShape);
}

function onAngleChange(event: Event) {
    const target = event.target as HTMLInputElement;
    emit('update:angle', target.valueAsNumber);
}

function validateAngleInput(event: Event) {
    const target = event.target as HTMLInputElement;

    if (!target.validity.badInput) {
        // Handle the 'e' case here
        return;
    }

    if (isNaN(target.valueAsNumber)) {
        target.value = String(props.angle);
        return;
    }
}

return { __sfc: true,externalCornerTypeImage, internalCornerTypeImage, shapeOptions, props, emit, onShapeChange, onAngleChange, validateAngleInput, JOINT_ANGLE_MAX, JOINT_ANGLE_MIN }
}

})